import React, { useState } from 'react';
import { LabeledInput, SelectInput } from '../../Components';
import './Business.css';
const Business = React.memo(() => {
    const [company, setCompany] = useState('');
    const [brand, setBrand] = useState('');
    const [gstin, setGSTIN] = useState('');
    const [add1, setAdd1] = useState('');
    const [add2, setAdd2] = useState('');
    const [landmark, setLandMark] = useState('');
    const [country, setCountry] = useState('Ind');
    const [pinCode, setPincode] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');

    return (
        <div className="business_profile">
            <div className="home_head">
                <h2 className="home_heading">Business Information</h2>
            </div>
            <div className="business_body">
                <div className="business_body_3col">
                    <LabeledInput
                        name="Company Name"
                        value={company}
                        changeHandler={(e) => {
                            setCompany(e.target.value);
                        }}
                        label={'Company Name'}
                    />
                    <div className="business_body_innerdiv">
                        <LabeledInput
                            style={{ width: '100%' }}
                            name="Brand Name"
                            value={brand}
                            changeHandler={(e) => {
                                setBrand(e.target.value);
                            }}
                            label={'Brand Name'}
                        />
                        <p className="input_info">
                            Your Brand name will be used in the ‘From’ address of the shipping label
                        </p>
                    </div>
                    <LabeledInput
                        name="GSTIN"
                        value={gstin}
                        changeHandler={(e) => {
                            setGSTIN(e.target.value);
                        }}
                        label={'GSTIN'}
                    />
                </div>
                <div className="business_body_3col">
                    <LabeledInput
                        name="Contact Name"
                        value={add1}
                        changeHandler={(e) => {
                            setAdd1(e.target.value);
                        }}
                        label={'Contact Name'}
                    />

                    <LabeledInput
                        name="Contact Number"
                        value={landmark}
                        changeHandler={(e) => {
                            setLandMark(e.target.value);
                        }}
                        label={'Contact Number'}
                    />
                    <div></div>
                </div>
                <div className="business_body_3col">
                    <LabeledInput
                        name="Address Line 1"
                        value={add1}
                        changeHandler={(e) => {
                            setAdd1(e.target.value);
                        }}
                        label={'Address Line 1'}
                    />
                    <LabeledInput
                        name="Address Line 2"
                        value={add2}
                        changeHandler={(e) => {
                            setAdd2(e.target.value);
                        }}
                        label={'Address Line 2'}
                    />

                    <LabeledInput
                        name="Land Mark"
                        value={landmark}
                        changeHandler={(e) => {
                            setLandMark(e.target.value);
                        }}
                        label={'Land Mark'}
                    />
                </div>
                <div className="business_body_4col">
                    <div>
                        <SelectInput
                            label="Country"
                            outlined={true}
                            value={country}
                            changeHandler={(e) => {
                                setCountry(e.target.value);
                            }}
                            options={[
                                { name: 'India', value: 'Ind' },
                                { name: 'United State', value: 'US' },
                                { name: 'United Kingdom', value: 'UK' },
                            ]}
                        />
                    </div>
                    <LabeledInput
                        name="Pincode"
                        value={pinCode}
                        changeHandler={(e) => {
                            setPincode(e.target.value);
                        }}
                        label={'Pincode'}
                    />
                    <LabeledInput
                        name="City"
                        value={city}
                        changeHandler={(e) => {
                            setCity(e.target.value);
                        }}
                        label={'City'}
                    />

                    <LabeledInput
                        name="State"
                        value={state}
                        changeHandler={(e) => {
                            setState(e.target.value);
                        }}
                        label={'State'}
                    />
                </div>
                <div className="footer_setting">
                    <button className="btn-orange">Save Changes</button>
                </div>
            </div>
        </div>
    );
});

export default Business;
